var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMountain01Trees(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    width: 3534.7,
    height: 5102.84,
    viewBox: "0 0 3534.7 5102.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "b"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M891.79,3151.74s-48.8,56.6-46.5,101.9c2.2,45.2,13.2,58.6-3.9,90.2-17.1,31.5-36.1,143.8,39.6,219.8,0,0,50.5-25,54.6-113.5,4.1-88.5-23.6-97.6-11.8-147.1,11.7-49.3-32-151.3-32-151.3Z",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M873.79,3594.74l8.1-361.3c.1-2.8,2.4-5.1,5.3-5.1,2.8,.1,5.1,2.4,5.1,5.3l-8.1,361.1h-10.4Z",
    style: {
      fill: "#88c163"
    }
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M138.69,2651.34s-48.8,56.6-46.5,101.9c2.2,45.3,13.2,58.7-3.9,90.2-17.2,31.5-36.1,143.8,39.6,219.8,0,0,50.5-25,54.6-113.5s-23.6-97.7-11.8-147.1c11.7-49.3-32-151.3-32-151.3Z",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.89,3099.04c-.1,2.8-2.4,5.1-5.3,5.1s-5.1-2.4-5.1-5.3l8.2-365.8c.1-2.8,2.4-5.1,5.3-5.1,2.8,.1,5.1,2.4,5.1,5.3l-8.2,365.8Z",
    style: {
      fill: "#568a5c"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "30.99 2848.14 122.49 3252.84 30.99 3252.84 30.99 2848.14",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.99 2641.94 215.29 3456.54 30.99 3456.54 30.99 2641.94",
    style: {
      fill: "#34635b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "143.2 4152.57 414.49 2720.94 719.95 4012.65 143.2 4152.57",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "83.46 4150.38 340.09 2762.64 617.57 4033.12 83.46 4150.38",
    style: {
      fill: "#366541"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.99 3486.84 194.79 2762.64 484.48 4080.9 16.93 4183.28 30.99 3486.84",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.78 4169.63 272.19 2897.64 542.49 4060.43 81.78 4169.63",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "464 4101.38 653.69 3032.74 897.41 4063.84 464 4101.38",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "498.13 4196.93 769.79 3084.94 979.32 4108.2 498.13 4196.93",
    style: {
      fill: "#366541"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "545.9 4111.62 705.99 3233.04 911.07 4128.68 545.9 4111.62",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "790.72 3928.57 951.19 3236.34 1125.96 3818.75 790.72 3928.57",
    style: {
      fill: "#18413d"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "876.94 3889.79 1031.99 3251.04 1170.43 3838.6 876.94 3889.79",
    style: {
      fill: "#88c163"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "992.97 3917.09 1141.09 3305.74 1221.62 3855.66 992.97 3917.09",
    style: {
      fill: "#366541"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1037.34 3923.92 1196.89 3337.04 1306.94 3876.14 1037.34 3923.92",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1197.73 3876.14 1345.59 3346.34 1436.62 3869.31 1197.73 3876.14",
    style: {
      fill: "#2a5254"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "1440.04 3667.96 1489.09 3450.84 1521.69 3594.74 1440.04 3667.96",
    style: {
      fill: "#34635b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "30.99 3491.74 54.29 3594.74 30.99 3594.74 30.99 3491.74",
    style: {
      fill: "#568a5c"
    }
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M30.99,2970.44c35.6-1.9,70.2,17.7,71.1,55.4,1.4,61.8-17.5,57.4,10,115.8,27.4,58.4,20.7,86.8,5.8,126-15,39.2,6.9,35.2,2.5,96-3.7,51.5-69.5,138.1-89.4,163.2v-556.4Z",
    style: {
      fill: "#88c163"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.99,3024.94c1.4-1.2,3.1-1.9,5-1.8,4.6,.1,8.2,4.6,8.2,9.9l-6.8,561.7h-6.4v-569.8Zm39.1-30.4c1.5-.4,2.2-1.9,1.8-3.4s-1.9-2.2-3.4-1.8c-.1,0-14.5,4.4-24.4,16.9-1,1.2-.8,2.8,.4,3.8,1.2,.9,2.8,.8,3.8-.4,8.9-11.2,21.8-15.1,21.8-15.1Zm15.1,445.9c1.5-.4,2.2-1.9,1.8-3.3-.4-1.5-1.9-2.3-3.4-1.9,0,0-21.7,6.6-36.8,25.4-1,1.2-.8,2.9,.4,3.8,1.2,1,2.8,.8,3.8-.4,14.1-17.5,34.1-23.6,34.2-23.6Zm24.7-52.7c1.5-.5,2.2-2,1.8-3.5-.5-1.4-2-2.2-3.5-1.7-.1,0-33.6,10.2-56.9,39.3-1,1.2-.8,2.8,.4,3.8s2.8,.8,3.8-.4c22.3-27.8,54.3-37.5,54.4-37.5Zm-11.3-38.6c1.5-.5,2.2-2,1.7-3.5-.4-1.4-1.9-2.2-3.4-1.7-.1,0-27,8.2-45.7,31.6-1,1.2-.8,2.9,.4,3.8,1.2,1,2.8,.8,3.8-.4,17.8-22,43.2-29.8,43.2-29.8Zm-9-40.1c1.5-.5,2.3-2,1.8-3.4-.4-1.5-1.9-2.3-3.4-1.9,0,.1-21.7,6.6-36.8,25.4-1,1.2-.8,2.9,.4,3.8,1.2,1,2.8,.8,3.8-.4,14.1-17.4,34.2-23.5,34.2-23.5Zm6.5-50.8c1.5-.4,2.2-1.9,1.8-3.3-.4-1.5-1.9-2.3-3.4-1.9-.1,.1-25.6,7.8-43.2,29.8-1,1.2-.8,2.9,.4,3.8,1.2,1,2.8,.8,3.8-.4,16.7-20.7,40.5-28,40.6-28Zm10.2-53.3c1.4-.4,2.2-1.9,1.8-3.4-.5-1.4-2-2.2-3.4-1.8-.1,.1-31.5,9.6-53.4,36.8-1,1.2-.8,2.9,.4,3.9,1.2,.9,2.8,.7,3.8-.4,20.9-26,50.6-35.1,50.8-35.1Zm-10.2-39.3c1.5-.5,2.2-1.9,1.8-3.4s-1.9-2.3-3.4-1.8c-.1,0-25.6,7.8-43.2,29.8-1,1.1-.8,2.8,.4,3.8,1.2,.9,2.8,.8,3.8-.4,16.7-20.7,40.5-28,40.6-28Zm-6.5-41.9c1.5-.4,2.3-1.9,1.8-3.4-.4-1.5-1.9-2.2-3.4-1.8,0,0-21.7,6.6-36.8,25.4-1,1.2-.8,2.8,.4,3.8,1.2,.9,2.8,.8,3.8-.4,14.1-17.4,34.2-23.6,34.2-23.6Zm0-46.3c1.5-.4,2.3-1.9,1.8-3.4-.4-1.4-1.9-2.2-3.4-1.8,0,0-21.7,6.6-36.8,25.4-1,1.2-.8,2.8,.4,3.8s2.8,.8,3.8-.4c14.1-17.5,34.2-23.6,34.2-23.6Zm0-46.3c1.5-.4,2.3-1.9,1.8-3.3-.4-1.5-1.9-2.3-3.4-1.9,0,0-21.7,6.6-36.8,25.4-1,1.2-.8,2.9,.4,3.8,1.2,1,2.8,.8,3.8-.4,14.1-17.5,34.2-23.6,34.2-23.6Z",
    style: {
      fill: "#2b4e48"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMountain01Trees);
export default __webpack_public_path__ + "static/media/mountain-01-trees.8395779fb392b983dd9abfab8af0270f.svg";
export { ForwardRef as ReactComponent };